import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProtocolService  {
    _originalTypeClassName = "zERP.BO.ProtocolService";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProtocolService.translate = translateService;
}
this.ProtocolServiceKey = null;
this._key = this.ProtocolServiceKey = 0; 
}

static translate: TranslateService;
_key: any;
private _ProtocolServiceKey:any;
get ProtocolServiceKey(): any {
    return this._ProtocolServiceKey;
  }
set ProtocolServiceKey(value: any) {
    this._ProtocolServiceKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ProtocolServiceKey == null || $this.ProtocolServiceKey == 0;
            }


}